
















































































































import Vue from 'vue';
export default Vue.extend({
  props: {
    isMobile: {
      type: Boolean,
    },
  },
  data() {
    return { text: '' };
  },
  methods: {
    async sendMessage() {
      await this.$store.dispatch('sendMessage', this.text);
      this.text = '';
    },
  },
});
